import { render, staticRenderFns } from "./IFieldDatetime.vue?vue&type=template&id=473e3520&"
import script from "./IFieldDatetime.vue?vue&type=script&lang=js&"
export * from "./IFieldDatetime.vue?vue&type=script&lang=js&"
import style0 from "./IFieldDatetime.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QTime from 'quasar/src/components/time/QTime.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QBtn,QTooltip,QPopupProxy,QDate,QSpace,QTime});qInstall(component, 'directives', {ClosePopup});
